export function parseQueryString(query: string): Record<string, string | string[]> {
  const params = new URLSearchParams(query)
  const obj: Record<string, string | string[]> = {}

  for (const [key, value] of params.entries()) {
    const existing = obj[key]

    if (existing !== undefined) {
      if (Array.isArray(existing)) {
        existing.push(value)
      }
      else {
        obj[key] = [existing, value]
      }
    }
    else {
      obj[key] = value
    }
  }

  return obj
}
